import script from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\VPicture.vue?type=script"
export * from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\components\\VPicture.vue?type=script"
export default script